import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@/hooks/useIsMobile';
import type { StockLevelItem } from '@/hooks/useInventory';

export function StockLocationBalances({ levels }: { levels: StockLevelItem[] }) {
  const { t } = useTranslation('inventory');
  const isMobile = useIsMobile();
  if (levels.length === 0)
    return <Typography color="text.secondary">{t('stockLocations.empty')}</Typography>;
  if (isMobile)
    return (
      <Box sx={{ display: 'grid', gap: 1 }}>
        {levels.map((level) => (
          <Paper key={level.id} variant="outlined" sx={{ p: 2 }}>
            <Typography fontWeight={600}>{level.warehouseName}</Typography>
            <Chip
              size="small"
              label={level.binLocationCode ?? t('stockLocations.noBin')}
              sx={{ my: 1 }}
            />
            <Typography variant="body2">
              {t('stockLocations.onHand')}: {level.quantityOnHand}
            </Typography>
            <Typography variant="body2">
              {t('stockLocations.reserved')}: {level.quantityReserved}
            </Typography>
            <Typography variant="body2">
              {t('stockLocations.available')}: {level.quantityOnHand - level.quantityReserved}
            </Typography>
          </Paper>
        ))}
      </Box>
    );
  return (
    <TableContainer>
      <Table size="small" aria-label={t('stockLocations.title')}>
        <TableHead>
          <TableRow>
            <TableCell>{t('stockLocations.warehouse')}</TableCell>
            <TableCell>{t('stockLocations.bin')}</TableCell>
            <TableCell align="right">{t('stockLocations.onHand')}</TableCell>
            <TableCell align="right">{t('stockLocations.reserved')}</TableCell>
            <TableCell align="right">{t('stockLocations.available')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {levels.map((level) => (
            <TableRow key={level.id}>
              <TableCell>{level.warehouseName}</TableCell>
              <TableCell>{level.binLocationCode ?? t('stockLocations.noBin')}</TableCell>
              <TableCell align="right">{level.quantityOnHand}</TableCell>
              <TableCell align="right">{level.quantityReserved}</TableCell>
              <TableCell align="right">{level.quantityOnHand - level.quantityReserved}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
